export default __webpack_public_path__ + "static/media/clonee.1b73c65e.svg";